import { customSendPdf } from "@crescentParts/Services/CustomWishListService";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GetWishListLinesApiParameter, SendWishListPdfApiParameter, } from "@insite/client-framework/Services/WishListService";
import { CallApi, chain } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SendWishListPdf";
import { PdfBarcodeDataFieldOptions, PdfBarcodeFormatOptions, PdfLayoutOptions } from "@insite/client-framework/Types/PrintPdfModels";

interface Parameter extends HasOnSuccess {
    lineIds?: string[];
    layout: PdfLayoutOptions;
    barcodeFormat: PdfBarcodeFormatOptions;
    barcodeField: PdfBarcodeDataFieldOptions;
    displayFields?: string[];
    addOverlay?: boolean;
    baseParameter: GetWishListLinesApiParameter;
}

type HandlerType = ApiHandlerDiscreteParameter<Parameter, SendWishListPdfApiParameter, ServiceResult<{}>>;

export const CallApiExtended: HandlerType = async props => {
    props.apiResult = await customSendPdf(props.apiParameter);
};

replaceInChain(chain, CallApi, CallApiExtended);